import RatingDistributionItem from './RatingDistributionItem';

export default RatingDistributionItem;
